enum ConfigKey {
  GRAPHQL_ENDPOINT,
  DATA_SOURCE_UNVERIFIED_BUCKET,
  REGION,
  USER_POOL_ID,
  USER_POOL_WEB_CLIENT_ID,
  USER_POOL_DOMAIN,
  IDENTITY_POOL_ID,
  ENVIRONMENT,
  CLOUDFRONT_URL,
  FEDERATED_SIEMENS_PROVIDER,
  FEDERATED_CUSTOMER_PROVIDER
  // add new config keys here ...
}

type ConfigKeyString = keyof typeof ConfigKey;

export function getKeys() {
  return Object.keys(ConfigKey).filter(key => isNaN(Number(key)));
}

export default ConfigKeyString;
